import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-permits-modal',
  templateUrl: './permits-modal.component.html',
  styleUrls: ['./permits-modal.component.scss'],
})
export class PermitsModalComponent implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder
  ) {}
  title: any;
  @Input()
  from!: string;
  nombre: any;
  securityForm!: FormGroup;
  @Input() data: any;
  isEdit: boolean = false;
  actualId: number = 0;
  ngOnInit(): void {
    this.createForm(this.from);
    if (this.from == 'permisos') {
      this.title = 'Añadir permisos';
      this.nombre = 'permiso';

      if (this.data) {
        console.log(this.data);

        this.pathForm(this.data);
        this.actualId = this.data.id;
      }
    } else if (this.from == 'roles') {
      this.title = 'Añadir rol de usuario';
      this.nombre = 'rol';
      if (this.data) {
        console.log(this.data);

        this.pathForm(this.data);
        this.actualId = this.data.id;
      }
    } else {
      this.nombre = 'permiso';
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
  }
  createForm(from: String) {
    switch (from) {
      case 'permisos':
        this.securityForm = this.formBuilder.group(AddPermit);
        break;
      case 'roles':
        this.securityForm = this.formBuilder.group(AddRole);
        break;

      default:
        break;
    }
  }
  pathForm(data: any) {
    this.securityForm.patchValue({
      name: data.name,
    });
    this.isEdit = true;
    console.log(this.securityForm.value);
  }
  btnAccept() {
    this.activeModal.close({
      type: 'accept',
      formValue: this.securityForm.value,
      edit: this.isEdit,
      id: this.actualId,
    });
  }

  btnClose() {
    this.activeModal.dismiss('close');
  }
  btnCancel() {
    this.activeModal.dismiss('cancel');
  }

  get name() {
    return this.securityForm.get('name');
  }
}

const AddPermit = {
  name: [
    '',
    Validators.compose([Validators.required, Validators.minLength(3)]),
  ],
};
const AddRole = {
  name: [
    '',
    Validators.compose([Validators.required, Validators.minLength(3)]),
  ],
};
